import axios from "axios";
import {
  GET_JOB_POSTS,
  JOB_ERROR,
  APPLY,
  ACCEPT_APPLICATION,
  DECLINE_APPLICATION,
  REMOVE_APPLICANT,
  DELETE_JOB_POST,
  DELETE_JOB_APPLICATION,
  ADD_JOB_POST,
  GET_JOB_POST,
  CLEAR_APPLICANT,
  CLEAR_JOBS,
  GET_APPLIED_JOBS,
} from "./types";

// Get job posts
export const getJobPosts = () => async (dispatch) => {
  try {
    const res = await axios.get("/api/jobs");

    dispatch({
      type: GET_JOB_POSTS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: JOB_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get applied jobs
export const getAppliedJobs = () => async (dispatch) => {
  try {
    const res = await axios.get("/api/jobs/applied_jobs");

    dispatch({
      type: GET_APPLIED_JOBS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: JOB_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get job posts by search terms
export const getJobPostsByTerms = (text) => async (dispatch) => {
  dispatch({ type: CLEAR_JOBS });

  const formData = new FormData();
  formData.append("terms", JSON.stringify(text));

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post("/api/jobs/terms", formData, config);

    dispatch({
      type: GET_JOB_POSTS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: JOB_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get user's job posts
export const getJobPostsById = (channelid) => async (dispatch) => {
  dispatch({ type: CLEAR_JOBS });

  try {
    const res = await axios.get(`/api/jobs/${channelid}`);
    dispatch({ type: CLEAR_JOBS });

    dispatch({
      type: GET_JOB_POSTS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: JOB_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get job post
export const getJobPostById = (id) => async (dispatch) => {
  dispatch({ type: CLEAR_JOBS });

  try {
    const res = await axios.get(`/api/jobs/${id}`);

    dispatch({
      type: GET_JOB_POST,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: JOB_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Add job post
export const createJobPost =
  (
    job,
    employmentType,
    workEnvironment,
    keywordsText,
    responsibilities,
    qualifications,
    benefits
  ) =>
  async (dispatch) => {
    const formData = new FormData();
    formData.append("Job", JSON.stringify(job));
    formData.append("EmploymentType", JSON.stringify(employmentType));
    formData.append("WorkEnvironment", JSON.stringify(workEnvironment));
    formData.append("Keywords", JSON.stringify(keywordsText));
    formData.append("Responsibilities", JSON.stringify(responsibilities));
    formData.append("Qualifications", JSON.stringify(qualifications));
    formData.append("Benefits", JSON.stringify(benefits));

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    try {
      const res = await axios.post("/api/jobs", formData, config);

      dispatch({
        type: ADD_JOB_POST,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: JOB_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Accept a application
export const acceptApplication =
  (JobApplication, currentIndex) => async (dispatch) => {
    const formData = new FormData();
    formData.append("application", JSON.stringify(JobApplication));
    formData.append("index", JSON.stringify(currentIndex));

    const config = {
      header: {
        "Content-Type": "application/json",
      },
    };

    try {
      const res = await axios.post(`/api/jobs/accept`, formData, config);

      dispatch({
        type: ACCEPT_APPLICATION,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: JOB_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Decline a application
export const declineApplication =
  (JobApplication, currentIndex) => async (dispatch) => {
    const formData = new FormData();
    formData.append("application", JSON.stringify(JobApplication));
    formData.append("index", JSON.stringify(currentIndex));

    const config = {
      header: {
        "Content-Type": "application/json",
      },
    };

    try {
      const res = await axios.post(`/api/jobs/decline`, formData, config);

      dispatch({
        type: DECLINE_APPLICATION,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: JOB_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Remove an accepted application
export const removeApplicant =
  (applicantResume, JobApplication) => async (dispatch) => {
    const formData = new FormData();
    formData.append("applicant", JSON.stringify(applicantResume));
    formData.append("application", JSON.stringify(JobApplication));

    const config = {
      header: {
        "Content-Type": "application/json",
      },
    };

    try {
      const res = await axios.post(
        `/api/jobs/removeapplicant`,
        formData,
        config
      );

      dispatch({
        type: REMOVE_APPLICANT,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: JOB_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Apply to a job post (unauthorized user)
export const apply =
  (attachmentFile, files, jobChannelId, jobId) => async (dispatch) => {
    const formData = new FormData();
    formData.append("attachments", JSON.stringify(attachmentFile));
    formData.append("channelid", JSON.stringify(jobChannelId));
    formData.append("id", JSON.stringify(jobId));

    files.map((file) => {
      formData.append("files", file);
    });

    const config = {
      data: formData,
      header: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    };

    try {
      const res = await axios.post(`/apply`, formData, config);

      dispatch({
        type: APPLY,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: JOB_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Apply to a job post (authorized user) IME resume
export const applyIMEResume = (jobId, jobChannelId) => async (dispatch) => {
  const formData = new FormData();
  formData.append("channelid", JSON.stringify(jobChannelId));
  formData.append("id", JSON.stringify(jobId));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(`/apply/imeresume`, formData, config);

    dispatch({
      type: APPLY,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: JOB_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Apply to a job post (authorized user) uploaded resume
export const applyIME =
  (attachmentFile, files, jobChannelId, jobId) => async (dispatch) => {
    const formData = new FormData();
    formData.append("attachments", JSON.stringify(attachmentFile));
    formData.append("channelid", JSON.stringify(jobChannelId));
    formData.append("id", JSON.stringify(jobId));

    files.map((file) => {
      formData.append("files", file);
    });

    const config = {
      data: formData,
      header: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    };

    try {
      const res = await axios.post(`/apply/ime`, formData, config);

      dispatch({
        type: APPLY,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: JOB_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Delete a application
export const deleteUserApplication =
  (email, channelid, id) => async (dispatch) => {
    const formData = new FormData();
    formData.append("email", JSON.stringify(email));
    formData.append("channelid", JSON.stringify(channelid));
    formData.append("id", JSON.stringify(id));

    const config = {
      header: {
        "Content-Type": "application/json",
      },
    };

    try {
      const res = await axios.post(`/removeapplication`, formData, config);

      dispatch({
        type: DELETE_JOB_APPLICATION,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: JOB_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Delete job post
export const deleteJobPost = (JobApplication) => async (dispatch) => {
  const formData = new FormData();
  formData.append("jobpost", JSON.stringify(JobApplication));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(`/api/jobs/delete_job_post`, formData, config);

    dispatch({
      type: DELETE_JOB_POST,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: JOB_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Delete job application
export const deleteApplication =
  (attachmentFile, jobChannelId, jobId) => async (dispatch) => {
    const formData = new FormData();
    formData.append("email", JSON.stringify(attachmentFile));
    formData.append("channelid", JSON.stringify(jobChannelId));
    formData.append("id", JSON.stringify(jobId));

    const config = {
      data: formData,
      header: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    };

    try {
      const res = await axios.post(
        `/api/jobs/removeapplication`,
        formData,
        config
      );

      dispatch({
        type: DELETE_JOB_APPLICATION,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: JOB_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

//Clear Jobs State
export const clearJobs = () => async (dispatch) => {
  try {
    dispatch({
      type: CLEAR_APPLICANT,
    });
  } catch (err) {
    dispatch({
      type: JOB_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
